<template>
    <div>
      <div class="navBar">
        <el-dropdown :hide-on-click="false" @command="handleCommand" class="userMsg">
          <span class="el-dropdown-link ">
            {{ user }}<i class="el-icon-caret-bottom el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command='setting'>设置</el-dropdown-item>
            <el-dropdown-item command='loginOut' divided>退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <Levelbar></Levelbar>
    </div>
</template>

<script>
import Levelbar from './Levelbar';
import cookie from './../../util/cookie'
export default {
  data(){
    return {
      user: localStorage.getItem('openUser') ?  JSON.parse(localStorage.getItem('openUser')).username : ''
    }
  },
  components:{
    Levelbar
  },
  methods:{
    handleCommand(command){
      if(command=='loginOut'){
        localStorage.removeItem('openUser');
        cookie.removeCookie('xToken');
        this.$router.push('/login');
        return ;
      }
      this.$router.push({ path: command });
    }
  }
}
</script>

<style rel='stylesheet/scss' lang="scss" scoped>
  .navBar{
    border-bottom: 1px solid #dadada;
    height: 66px;
    background: #363636;
      .userMsg{
        color: #fff ;
        line-height: 66px;
        float: right;
        margin-right: 50px;
      }
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/Navbar.vue?1b5f9504